import { styleSectionDelivery } from "./style";
import { colors, styleScreenDashboard } from "../../styles/style";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Card } from "react-bootstrap";

import ButtonCustom from "../buttons/buttonCustom";

const OptionNone = ({ orderId, selectOrder }) => {
  return (
    <div style={styleSectionDelivery.container}>
      <div style={styleSectionDelivery.containerButton}>
        <ButtonCustom
          text={"Asignar repartidor"}
          type={"orange"}
          functionBtn={() => selectOrder(orderId)}
        />
      </div>
    </div>
  );
};

const OptionSelected = ({ orderId, abortAction }) => {
  return (
    <div className={"row"} style={styleSectionDelivery.containerSelected}>
      <div className={"col-1"}>
        <AiOutlinePlusCircle size={26} color={colors.GRAY_4_COLOR} />
      </div>
      <div className={"col row"}>
        <p className="col-8" style={styleSectionDelivery.textOptionSelected}>
          Selecciona un repartidor
        </p>
        <div className="col d-flex align-items-center">
          <ButtonCustom
            text={"Cancelar acción"}
            type={"gray"}
            functionBtn={() => abortAction(orderId)}
          />
        </div>
      </div>
    </div>
  );
};

const OptionDroped = ({ infoDelivery, orderId, createOrder, abortAction }) => {
  return (
    <div style={styleSectionDelivery.normalContainer}>
      <div className={"row"} style={styleSectionDelivery.containerButton}>
        <div className="col">
          <Card style={styleScreenDashboard.borderCards}>
            <Card.Body>
              <Card.Text>
                {infoDelivery.name + " " + infoDelivery.last_name}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
        <div
          className="col"
          style={{
            alignItems: "center",
            alignContent: "end",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <ButtonCustom
            text={"Asignar orden"}
            type={"orange"}
            functionBtn={() => createOrder(orderId)}
          />
          <ButtonCustom
            text={"Cancelar acción"}
            type={"gray"}
            functionBtn={() => abortAction(orderId, infoDelivery.id)}
          />
        </div>
      </div>
    </div>
  );
};

/**
 * @param {Object} order Información de la orden
 * @returns Component to add and see a delivery selected in the dashboard
 */
const sectionDelivery = ({
  order,
  selectOrder,
  createOrder,
  abortAction,
  vehicle,
}) => {
  switch (order.deliveryState) {
    case "none":
      return <OptionNone orderId={order.id} selectOrder={selectOrder} />;
    case "selected":
      return (
        <OptionSelected orderId={order.id} abortAction={abortAction} />
      );
    case "droped":
      if (order.shop_comments === "SOLUTIONS") {
        if (order.delivery_man_id.delivery_transport === vehicle)
          return (
            <OptionDroped
              infoDelivery={order.delivery_man_id}
              orderId={order.id}
              createOrder={createOrder}
              abortAction={abortAction}
            />
          );
        else abortAction(order.id);
      } else
        return (
          <OptionDroped
            infoDelivery={order.delivery_man_id}
            orderId={order.id}
            createOrder={createOrder}
            abortAction={abortAction}
          />
        );
      break;

    default:
      return <OptionNone orderId={order.id} selectOrder={selectOrder} />;
  }
};

export default sectionDelivery;
